export default function () {
    const entityEvent = useEntityEvent();

    async function get(filter) {
        let events = null,
            error = null,
            hasMore = false;
        try {
            const {data} = await useApi('events').get('events', filter);
            events = data.events.map((event) => {
                return entityEvent.build(event);
            });
            hasMore = events.length === filter?.paginate?.limit;
        } catch (e) {
            error = useApiError(e);
        }
        return {events, error, hasMore};
    }

    return {get};
}
